<template>
	<a-modal v-model="isShow" title="导出日志" width="90%" :footer="null" :maskStyle="maskStyle">
		<div>
			<a-table :columns="columns" :dataSource="dataList" :pagination="pagination" @change="handleTableChange" :loading="loading" bordered>
				<div slot="createdOn" slot-scope="value">{{ value | formatDate('yyyy-MM-dd HH:mm:ss') }}</div>
				<template slot="action" slot-scope="text, row">
					<a @click="download(row)">下载</a>
				</template>
			</a-table>
		</div>
	</a-modal>
</template>

<script>
	import columns from './columns.json'
	export default {
		computed: {
			localizedItemTxt() {
				return this.$store.state.reportInfo.localizedItemTxt;
			}
		},
		data() {
			return {
				isShow: false,
				columns,
				dataList: [],
				loading: false,
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				maskStyle: {
					background: 'none'
				}
			}
		},
		watch: {
			'$store.state.reportInfo.localizedItemTxt': function() {
				this.isShow = false;
			}
		}
		,
		methods: {
			show() {
				this.isShow = true;
				this.loadData()
			},
			loadData() {
				let rptTxt = JSON.parse(this.$store.state.reportInfo.urlParams)?.rptTxt
				let params = {
					rptName: rptTxt || this.localizedItemTxt,
					pageIndex: this.pagination.current,
					pageSize: this.pagination.pageSize
				}
				this.dataList = []
				this.loading = true;
				this.$axios.PagingExportLogs(params).then(response => {
					if(response && response.success) {
						this.dataList = response.content.rows.map((ele, i) => Object.assign(ele, {
							key: i.toString()
						}));
						this.loading = false;
						this.pagination.total = response.content.total;
					}
				})
			},
			// 翻页、排序等等操作
			handleTableChange(pagination, filters, sorter) {
				console.log(pagination, filters, sorter);
				this.pagination.current = pagination.current;
				this.loadData();
			},
			// 下载
			download(row) {
				if(row.status == 2) {
					window.open(row.filePath)
				} else {
					this.$message.info("文件正在努力生成中，请稍后刷新重试");
				}
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">

</style>